import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class PropertyRouteVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyrouteCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyrouteCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyrouteReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyrouteRead,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyrouteDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyrouteDelete,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationPropertyrouteUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationPropertyrouteUpdate,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationPropertyrouteCreateany,
        PermissionAttributesEnum.GlobalOperationPropertyrouteUpdateany,
        PermissionAttributesEnum.GlobalOperationPropertyrouteDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationPropertyrouteCreate,
        PermissionAttributesEnum.ContextOperationPropertyrouteUpdate,
        PermissionAttributesEnum.ContextOperationPropertyrouteDelete,
      ],
    });
  };
}
